<template>
  <div class="tnf">
    <div class="tnf-glow tnf-glow-1"></div>
    <div class="tnf-glow tnf-glow-2"></div>

    <div class="tnf-card">
      <div class="tnf-icon" aria-hidden="true">
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="9" />
          <line x1="8" y1="8" x2="16" y2="16" />
        </svg>
      </div>

      <h1 class="tnf-title">{{ $t('ui.tenantNotFound.title') }}</h1>

      <p class="tnf-body">
        <template v-if="subdomain">
          {{ $t('ui.tenantNotFound.bodyWithSub', { subdomain }) }}
        </template>
        <template v-else>
          {{ $t('ui.tenantNotFound.body') }}
        </template>
      </p>

      <a class="tnf-cta" :href="mainSiteUrl">{{ $t('ui.tenantNotFound.cta') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TenantNotFound',
  props: {
    subdomain: { type: String, default: '' },
  },
  computed: {
    mainSiteUrl() {
      return 'https://new.measureup.com';
    },
  },
};
</script>

<style scoped>
.tnf {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--pls-brand-bg, #0d1f3c);
  color: #fff;
  font-family: var(--pls-font, 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
  overflow: hidden;
}

.tnf-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.5;
  pointer-events: none;
}
.tnf-glow-1 {
  width: 420px;
  height: 420px;
  top: -120px;
  right: -80px;
  background: var(--pls-primary, #0080c9);
}
.tnf-glow-2 {
  width: 360px;
  height: 360px;
  bottom: -140px;
  left: -100px;
  background: var(--pls-primary, #0080c9);
  opacity: 0.28;
}

.tnf-card {
  position: relative;
  z-index: 1;
  max-width: 460px;
  width: 100%;
  text-align: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  padding: 40px 32px;
  backdrop-filter: blur(6px);
}

.tnf-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 68px;
  margin-bottom: 20px;
  border-radius: 50%;
  color: var(--pls-primary, #0080c9);
  background: rgba(255, 255, 255, 0.08);
}

.tnf-title {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
}

.tnf-body {
  margin: 0 0 26px;
  font-size: 15px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
}

.tnf-body :deep(strong),
.tnf-body strong {
  color: #fff;
  font-weight: 700;
}

.tnf-cta {
  display: inline-block;
  padding: 12px 24px;
  border-radius: 10px;
  background: var(--pls-primary, #0080c9);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.15s ease;
}
.tnf-cta:hover {
  background: var(--pls-primary-dark, #006aa6);
}
</style>
